// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"b8711f49","110":"14a4f8d3","127":"f184f7c8","154":"73facec3","337":"ba35026b","369":"df02d189","671":"01d65ef6","692":"cb86230c","876":"378b8307"}[chunkId] + ".chunk.js";
};